import { createRoot } from 'react-dom/client'
import RecentlyViewedCarouselInit from './components/RecentlyViewedCarouselInit'

const productJsonDataEl = document.querySelector('[data-product-json]')
const productJsonData = productJsonDataEl ? JSON.parse(productJsonDataEl.innerHTML) : {}
const container = document.getElementById('ss-recently-viewed-carousel')!
const root = createRoot(container)
root.render(
  <RecentlyViewedCarouselInit productJsonData={productJsonData} />
)